module.exports = __webpack_public_path__ + "img/MARITIMEBANK.24dbef27.svg";